/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Tournament_Seat_NInputs */



/**
* | output |
* | --- |
* | "Seat {n}" |
*
* @param {Tournament_Seat_NInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_seat_n = /** @type {((inputs: Tournament_Seat_NInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Seat_NInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Siège ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Asiento ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Assento ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posto ${i?.n}`)
	return /** @type {LocalizedString} */ (`Seat ${i?.n}`)
});